import Action from '../../../decorators/Action';
import Computed from '../../../decorators/Computed';
import Observable from '../../../decorators/Observable';
import AbstractEntity from './AbstractEntity';
import IKeywordsEntity from './IKeywordsEntity';

export default class AreaEntity
  extends AbstractEntity
  implements IKeywordsEntity
{
  public readonly type = 'AreaEntity';

  @Observable()
  public data: {
    checked: boolean;
    id: number | string;
    displayName: string;
    name: string;
    keywords: string[];

    checkedKeywords?: string[];
    customAddedKeywords?: string[];

    isCustom?: boolean;
    // indicates if the step with the area keywords is processed by the user
    areKeywordsProvided?: boolean;
  } = null;

  constructor(data) {
    super();

    this.data = data;
    if (this.data.isCustom) {
      this.data.id = 'custom_' + data.name;
    }

    this.data.keywords = this.data.keywords || [];
    this.data.checkedKeywords = this.data.checkedKeywords || [];
    this.data.customAddedKeywords = this.data.customAddedKeywords || [];
    this.data.areKeywordsProvided = this.data.areKeywordsProvided || false;

    this.initFields();
  }

  setAreaKeywordsProvided(value: boolean): void {
    throw new Error('Method not implemented.');
  }

  static fromJSON(json: any): AreaEntity {
    if (json === null) {
      return null;
    }

    return new AreaEntity(json.data);
  }

  @Computed()
  get isCustomArea(): boolean {
    return this.data.isCustom;
  }

  @Action()
  public setChecked(value: boolean): void {
    this.data.checked = value;
  }

  @Action()
  public setKeywords(keywords: string[]): void {
    this.data.keywords = keywords;
  }

  @Computed()
  get isChecked(): boolean {
    return this.data.checked;
  }

  @Computed()
  get displayName(): string {
    return this.data.displayName;
  }

  @Computed()
  get name(): string {
    return this.data.name;
  }

  @Computed()
  get id(): number | string {
    return this.data.id;
  }

  public getEntityType(): string {
    return this.type;
  }

  public getSessionKey(): string {
    return 'AreaEntity' + this.data.id;
  }
}
